var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliverySuccess = function SvgDeliverySuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M32.45 29.004a1.5 1.5 0 1 1 2.268 1.964l-3.45 3.985a.5.5 0 0 1-.737.02l-2.37-2.452a1.5 1.5 0 0 1 2.157-2.085l.471.487 1.66-1.919zm-.96 9.982a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3c-5.8 0-10.5-4.701-10.5-10.5s4.7-10.5 10.5-10.5c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5zm-6-30v-4.5h3v7a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-7h3v4.5h6zm-12 15a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm25.475-2.953h-3V10.5a1.5 1.5 0 0 0-1.5-1.5H10.5A1.5 1.5 0 0 0 9 10.5v18.017a1.5 1.5 0 0 0 1.5 1.5h11.99v3H10.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 10.5 6h23.965a4.5 4.5 0 0 1 4.5 4.5v13.533z"
  })));
};
export default SvgDeliverySuccess;